module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error"
  }, [_vm._v("\n  404: Not Found\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b5d5bd9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Error.vue
// module id = 127
// module chunks = 1